import { render, staticRenderFns } from "./ListSalesPaymentPage.vue?vue&type=template&id=4065aa58"
import script from "./ListSalesPaymentPage.vue?vue&type=script&lang=js"
export * from "./ListSalesPaymentPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports